module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1920-bf7481593e6695cae88b9d86bd3d53b8.webp";